// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Animation for Error  */
@keyframes up {
  0% {
    transform: translateY(20%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.error {
  height: calc(100vh - 300px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
}
.error > * {
  animation: up 0.3s linear forwards;
  opacity: 0;
}
.error img {
  max-width: 300px;
  max-height: 300px;
}

.error h4 {
  font-size: 24px;
  animation-delay: 0.3s;
}
.error p {
  font-size: 18px;
  animation-delay: 0.6s;
}
`, "",{"version":3,"sources":["webpack://./src/components/error-fallback/error-fallback.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB","sourcesContent":["/* Animation for Error  */\n@keyframes up {\n  0% {\n    transform: translateY(20%);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.error {\n  height: calc(100vh - 300px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n}\n.error > * {\n  animation: up 0.3s linear forwards;\n  opacity: 0;\n}\n.error img {\n  max-width: 300px;\n  max-height: 300px;\n}\n\n.error h4 {\n  font-size: 24px;\n  animation-delay: 0.3s;\n}\n.error p {\n  font-size: 18px;\n  animation-delay: 0.6s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
